import type { RouteObject } from 'react-router-dom'

import { Component } from '@/modules/netWorth/pages/NetWorth'
import { NetWorthRoutePathsEnum } from '@/modules/netWorth/routes/netWorthRouteConfig.types'

export const NET_WORTH_ROUTES: RouteObject[] = [
  {
    element: <Component />,
    path: NetWorthRoutePathsEnum.NET_WORTH,
  },
]
